import { Start } from 'base/src/main.tsx'
import { CarteiraRouter } from './infra/routes/carteiraRoutes.tsx'
import { CarteiraReducerList } from './store/carteiraReducer.ts'
import { sideBarOptions } from './infra/routes/sideBarOptions.ts'

import { LangList } from 'base/i18n.ts';
import translationEN from "./lang/en/translation.json";
import translationPT from "./lang/pt/translation.json";
import { SistemaList } from 'domain/types/sistema/sistemaList.ts';
import { CarteiraValor } from 'domain/components/_carteira';
import CarteiraProvider  from '../src/utils/context/carteiraContext';

const langList: LangList = {
    en: translationEN,
    pt: translationPT
}

Start({
    headerLeftInfo: <CarteiraValor />,
    sistemaID: SistemaList.carteira,
    storeRoot: CarteiraReducerList,
    routes: CarteiraRouter,
    sidebarOptions: sideBarOptions,
    langList: langList,
    titulo: "WebDecisor - Carteira",
    customWrapper: CarteiraProvider
})